import { FetchCollectionResult, FetchResultType } from '@/entities/FetchResult'
import { authorizedFetch } from '@/helpers/authorizedFetch'
import { formatDate } from '@/helpers/date'
import { trans } from '@/helpers/trans'
import { generateApiUrl } from '@/helpers/url'
import { isResourceCollectionDocument } from '@/japi/guards/isResourceCollectionDocument'
import { JapiDocument } from '@/japi/types/Document'
import { DateFormat } from '@/types'

import { SpecialDay, SpecialDayResource } from './SpecialDay'
import { transformToSpecialDay } from './SpecialDayTransformers'

export const getSpecialDayIndexCall = async (
    startDate: Date,
    endDate: Date,
): Promise<FetchCollectionResult<SpecialDay[], string>> => {
    try {
        const url = generateApiUrl({
            endpoint: '/special-days',
            queryParams: {
                startDate: formatDate(startDate, DateFormat.apiDateTime),
                endDate: formatDate(endDate, DateFormat.apiDateTime),
            },
        })

        const response = await authorizedFetch(url)

        const doc: JapiDocument = await response.json()

        if (! isResourceCollectionDocument<SpecialDayResource>(doc) || ! doc.data) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        const specialDays = doc.data.map(transformToSpecialDay)

        return {
            amountOfPages: 1,
            status: response.status,
            type: FetchResultType.Success,
            data: specialDays,
        }
    } catch (error) {
        console.error('[getSpecialDayIndexCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}
